<apm-section-title [title]="(('446063' | apmTranslate) ?? '') + ' ' + title()"></apm-section-title>
<div class="statistic-data-list row">
  @for (data of statisticDataFiltered(); track $index) {
    <div class="col-6 mb-3">
      <div
        class="apm-card shadow h-100"
        [ngClass]="{ selected: data.statisticCode === selectedStatisticsCode()?.statisticCode }"
        (click)="selectStatistic(data)"
      >
        @if (data.icon) {
          <fa-icon class="d-block mb-1" size="xl" [icon]="data.icon"></fa-icon>
        }
        <div>{{ data.resourceId | apmTranslate }}</div>
      </div>
    </div>
  }
</div>
